// extracted by mini-css-extract-plugin
export default {"rightSide2":"style_rightSide2__JKVyW","rightSide":"style_rightSide__xG6Nb"};